import theme, { fontFamily } from "@/theme";

export const styles = {
  Sidebarheader: {
    paddingLeft: "16px",
    paddingTop: "12px",
    paddingBottom: "10px",
    display: "flex",
    alignItems: "center",
  },

  MarketSelection: {
    width: "40px",
    height: "28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "2px",
    borderRadius: "50%",
  },
  logoBox: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  sidebarWrapper: {
    overflow: "auto",
    height: "100%",
    borderRight: "1px solid #F5F5F5",
  },

  userInfoDiscount: {
    fontSize: "0.8125rem",
    padding: "0.0625rem 0.25rem",
    maxWidth: "fit-content",
    letterSpacing: "-0.02em",
    borderRadius: "0.3125rem",
  },

  listItemIcon: (isActive: boolean) => ({
    minWidth: 18,
    width: 18,
    height: 18,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    svg: { width: 18, height: 18 },
    path: {
      stroke: isActive ? theme.palette.custom.mainBlue : theme.palette.custom.blueGray900,
    },
  }),
  listItemText: {
    lineHeight: "20px",
    fontSize: "14px",
    fontWeight: "500",
  },

  card: {
    width: "100%",
    height: "97px",
    padding: "10px 12px",
    borderRadius: "10px",
    backgroundColor: "#F7F9FB",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    cursor: "pointer",
    height: "23px",
    display: "flex",
    alignItems: "center",
    marginBottom: "16px",
  },
  title: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "16px",
    color: "#0070f3",
  },
  subtitle: {
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: "14px",
    color: "#7a7f85",
  },
  button: {
    width: "100%",
    height: "38px",
    padding: "10px 20px",
    borderRadius: "6px",
    backgroundColor: "#FFFFFF",
    color: "#2A2D31",

    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "15px",
    lineHeight: "100%",
    boxShadow: "none",
    whiteSpace: "nowrap",
    textTransform: "none",

    "&:hover": {
      backgroundColor: "#F2F2F2",
      boxShadow: "none",
    },
  },
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1300,
  },
  balanceCard: {
    width: "220px",
    minHeight: "182px",
    padding: "10px 12px",
    borderRadius: "10px",
    backgroundColor: "#F7F9FB",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },

  balance: {
    minHeight: "61px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "12px",
  },
  balanceNav: {
    height: "16px",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  walletIcon: {
    width: "18px",
    height: "16px",
  },

  balanceTitle: {
    fontFamily: fontFamily.inter,
    fontWeight: 600,
    fontSize: "13px",
    lineHeight: "16px",
    letterSpacing: "-2%",
    color: theme.palette.custom.blueGray900,
  },

  dropdownIcon: {
    minWidth: 0,
    padding: 0,
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "none",
    boxShadow: "none",
    width: "12px",
    height: "12px",
    cursor: "pointer",
    "& svg": {
      width: "12px",
      height: "12px",
    },
  },

  logoutIcon: {
    minWidth: 0,
    padding: 0,
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "none",
    boxShadow: "none",
    cursor: "pointer",
  },

  balanceAmount: {
    fontFamily: fontFamily.inter,
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "18px",
    letterSpacing: "0%",
    color: "#000000",
  },

  balanceUsd: {
    fontFamily: fontFamily.inter,
    fontWeight: 500,
    fontStyle: "medium",
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "-0.12px",
    color: theme.palette.custom.mainBlue,
    height: "18px",
  },

  balanceActions: {
    width: "100%",
    borderTop: "1px solid #E4E7E9",
    padding: "11px 0px 10px 0px",
    display: "flex",
    justifyContent: "space-between",
  },

  balanceAction: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
  },

  balanceActionButton: {
    width: "26px",
    height: "26px",
    minWidth: 0,
    padding: 0,
    borderRadius: "50%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  balanceActionText: {
    fontFamily: fontFamily.inter,
    fontWeight: 600,
    fontSize: "10px",
    lineHeight: "10px",
    letterSpacing: "-0.01em",
    color: "#000000",
  },
  walletWrapper: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  },
  userInfoWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    height: "64px",
    marginTop: "16px",
    padding: "6px 0",
  },

  badge: {
    backgroundColor: "rgba(42, 170, 255, 0.1)",
    borderRadius: "5px",
    padding: "1px 4px",
    display: "inline-block",
    marginBottom: "2px",
  },

  badgeText: {
    color: theme.palette.custom.mainBlue,
    fontSize: "13px",
    fontWeight: 500,
    fontFamily: "Poppins",
    lineHeight: "normal",
    letterSpacing: "-0.26px",
  },

  badgeTextRank: {
    fontWeight: 600,
  },

  username: {
    fontSize: "14px",
    fontWeight: 500,
    fontFamily: "Inter",
    color: "#2A2D31",
    lineHeight: "16px",
  },
  divider: {
    height: "1px",
    width: "82%",
    backgroundColor: "#E4E7E9",
    marginTop: "1rem",
  },
  dividerWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  socialLinksWrapper: {
    borderTop: "1px solid #E4E7E9",
    paddingTop: "16px",
    width: "100%",
  },
  socialLinksWrapperNoDivider: {
    paddingTop: "16px",
    width: "100%",
  },
  socialLinksRow: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    paddingLeft: "8px",
  },
  socialLinkIcon: {
    display: "flex",
    cursor: "pointer",
  },
  buttonText: {
    width: "100%",
    height: "48px",
    borderRadius: "33px",
    padding: "12px",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "15px",
    lineHeight: "24px",
    letterSpacing: "-1%",
    textTransform: "none",
  },
};
